import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import usePrefersReducedMotion from '../../hooks/usePrefersReducedMotion';
import { assetUrl } from '../../lib/assetUrl';
import './Hero.css';

const HERO_IMAGES = [
  {
    id: 'dog-and-kitten',
    src: 'images/hero/pets-1.jpg',
    alt: 'A golden dog resting its head beside a sleeping grey kitten',
  },
  {
    id: 'brown-dog',
    src: 'images/hero/pets-2.jpg',
    alt: 'A brown dog resting its head on the arm of a sofa',
  },
];

const SLIDE_INTERVAL_MS = 6000;

export default function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) return undefined;

    const timer = window.setInterval(() => {
      setActiveIndex((index) => (index + 1) % HERO_IMAGES.length);
    }, SLIDE_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [activeIndex, prefersReducedMotion]);

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="container hero__inner">
        <div className="hero__content">
          <p className="eyebrow">Veterinary care in Phnom Penh</p>
          <h1 id="hero-title">Advancing Pet Care Across Asia</h1>
          <p className="lead">
            Comprehensive, compassionate and expert care for your pets, from check-ups and
            surgery to grooming, boarding and relocation.
          </p>
          <div className="hero__actions">
            <Link className="btn btn--primary" to="/Service">
              Explore Services
            </Link>
            <a className="btn btn--secondary" href="#contact">
              Contact Us
            </a>
          </div>
        </div>

        <div className="hero__media">
          <div className="hero__visual">
            <div className="hero__frame">
              {HERO_IMAGES.map((image, index) => {
                const isActive = index === activeIndex;
                return (
                  <img
                    key={image.id}
                    src={assetUrl(image.src)}
                    alt={image.alt}
                    width="1100"
                    height="1375"
                    className={isActive ? 'hero__image is-active' : 'hero__image'}
                    aria-hidden={!isActive}
                    loading={index === 0 ? 'eager' : 'lazy'}
                  />
                );
              })}
            </div>
          </div>
          <div className="hero__dots" role="group" aria-label="Choose hero photo">
            {HERO_IMAGES.map((image, index) => (
              <button
                key={image.id}
                type="button"
                className={index === activeIndex ? 'hero__dot is-active' : 'hero__dot'}
                aria-label={`Show photo ${index + 1} of ${HERO_IMAGES.length}`}
                aria-pressed={index === activeIndex}
                onClick={() => setActiveIndex(index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
